<div class="col-md-12 mb-30" [hidden]="View_Form_Switcher!='List'">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">اطلاعیه های سیستم</h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">تاریخ شروع</label>
        <input type="text" #datepickerInputStart placeholder="اینجا تایپ کنید ..." class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
          [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">تاریخ پایان</label>
        <input type="text" #datepickerInputEnd placeholder="اینجا تایپ کنید ..." class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
          [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
      </div>
    </div>
     <div class="row">
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">عنوان</label>
        <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
          class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">ایجاد کننده</label>
        <input [(ngModel)]="Filter_username" (keyup)="Change_Filter_title()" name="Filter_username" type="text"
          class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">متن اطلاعیه</label>
        <input [(ngModel)]="Filter_dsc" (keyup)="Change_Filter_title()" name="Filter_dsc" type="text"
          class="form-control" placeholder="برای جستجوی ، اینجا تایپ کنید ...">
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="ReadData_Alert(datepickerInputStart.value,datepickerInputEnd.value)"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
        <button *ngIf="!Procssing" (click)="set_Alert_New()" type="button"  class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> فرم ثبت اطلاعات جدید </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>شناسه</th>
              <th>عنوان</th>
              <th>تاریخ انقضاء</th>
              <th>گیرنده</th>
              <th>ایجاد کننده</th>
              <th>ناریخ</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Alert
            |filter:Filter_title:'title'
            |filter:Filter_username:'username'
            |filter:Filter_dsc:'message'
            | paginate
                    : {
                        id: 'DataList_UserTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Alert
                        |filter:Filter_title:'title'
                        |filter:Filter_username:'username'
                        |filter:Filter_dsc:'message'
                        ).length
                      }
            ">
             <td>{{DataList_Alert.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.title}}</td>
              <td>{{item.expirationData}}</td>
              <td>{{item.giver}}</td>
              <td>{{item.username}}</td>
              <td>{{item.persianData}}</td>
              <td>
                <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          امکانات
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" class="dropdown-item" (click)="on_Set_View(item,templateView)" ><i class="fa fa-eye"></i> مشاهده </a>
                          <a style="cursor: pointer;" class="dropdown-item" (click)="set_Alert_Record(item)" ><i class="fa fa-edit"></i> ویرایش </a>
                          <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> حذف </a>
                      </div>
                  </div>

                  <div *ngIf="item.DeletingProccess" >
                    <img  src="assets/Loading.gif" style="width: 25px;" />
                  </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_UserTable"
     nextLabel="بعدی"
     previousLabel="قبلی"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>

<div *ngIf="View_Form_Switcher=='Form'">
  <app-AlertForm
    [inner_Alert]="Data_Seleted_Alert"
  >

  </app-AlertForm>
  <button (click)="back_AlertList()" type="button" class="btn btn-warning"><i
    class="fa fa-mail-reply"></i> بازگشت </button>
</div>

<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">تایید حذف اطلاعیه '{{Data_Seleted_Alert.code}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Alert)"> حذف اطلاعات <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">بستن</button>
  </div>
</ng-template>


<ng-template #templateView>
  <div class="modal-header">
     <h4 class="modal-title pull-left">  اطلاعیه - {{Data_Seleted_Alert.title}} </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Alert.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div  class="acd-des" innerHTML="{{Data_Seleted_Alert.message}}"></div>

    <br/>
    <ul>
        <li *ngFor="let file of Data_Seleted_Alert.files">
          <a target="_blank" href="{{BaseUrl}}File/Alert/{{file}}"  ><i class="fa fa-download"></i>
             فایل پیوست شده شماره {{Data_Seleted_Alert.files.indexOf(file)+1}}
          </a>
        </li>
    </ul>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="modalRef_Alert.hide()" class="btn btn-danger"><i class="fa fa-eye-slash"></i> مشاهده شد </button>
  </div>
</ng-template>
